const KeyHandling = options => {
	// On return, if at the end of a node type that should not be extended,
	// create a new paragraph below it and remove marks
	const onEnterKeyDown = (event, editor, next) => {
		const { value } = editor
		const { selection } = value
		const { start, end, isExpanded } = selection

		// If shift key is pressed, keep default behaviour
		// F. ex. SoftBreak({ shift: true }), Shift + Enter in Headline
		const { startBlock } = value

		if (
			event.shiftKey ||
			isExpanded ||
			(start.offset === 0 && startBlock.text.length === 0)
		)
			return next()

		if (
			end.offset !== startBlock.text.length ||
			(startBlock.type !== 'heading-two' &&
				startBlock.type !== 'heading-three' &&
				startBlock.type !== 'block-quote')
		) {
			editor.value.marks.map(mark => editor.removeMark(mark))

			return next()
		}

		event.preventDefault()
		editor
			.splitBlock()
			.setBlocks('paragraph')
			.value.marks.map(mark => editor.removeMark(mark))
	}

	// Not sure what this is needed for
	const onEnterKeyUp = (event, editor, next) => {
		const {
			value: {
				previousBlock,
				selection: { start },
			},
		} = editor

		if (
			start.offset === 0 &&
			previousBlock &&
			previousBlock.type !== 'paragraph' &&
			!previousBlock.text.length &&
			!editor.isVoid(previousBlock)
		) {
			// Transform previous block to paragraph
			editor.replaceNodeByKey(previousBlock.key, {
				object: 'block',
				type: 'paragraph',
			})
		}
	}

	return {
		onKeyDown(event, editor, next) {
			switch (event.key) {
				case 'Enter':
					return onEnterKeyDown(event, editor, next)
				default:
					return next()
			}
		},
		onKeyUp(event, editor, next) {
			switch (event.key) {
				case 'Enter':
					return onEnterKeyUp(event, editor, next)
				default:
					return next()
			}
		},
	}
}

export default KeyHandling
